import {FirebaseError} from 'firebase/app';
import {sendEmailVerification} from 'firebase/auth';
import {useCallback, useState} from 'react';
import {useLogger} from '../../logging/LoggerProvider';
import {useAuthUser} from './useAuthUser';

export interface UseSendVerificationEmail {
  errorCode?: string;
  errorMessage?: string;
  isSending: boolean;
  sendVerificationEmail: () => Promise<void>;
}

/* v8 ignore next -- @preserve */
export function useSendVerificationEmail(): UseSendVerificationEmail {
  const [errorCode, setErrorCode] = useState<string | undefined>();
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [isSending, setSending] = useState<boolean>(false);
  const user = useAuthUser();
  const logger = useLogger();
  const sendVerificationEmail: () => Promise<void> = useCallback(async () => {
    setSending(true);
    try {
      logger.debug(`[SendVerificationEmail] Sending verification email to: ${user.data?.email}`);
      await sendEmailVerification(user.data);
      logger.info(`[SendVerificationEmail] Verification email sent successfully to: ${user.data?.email}`);
    } catch (error) {
      logger.error('[SendVerificationEmail] Error sending verification email', error);
      const firebaseError = error as FirebaseError;
      setErrorCode(firebaseError.code);
      setErrorMessage(firebaseError.message);
    } finally {
      setSending(false);
    }
  }, [logger, setSending, user.data]);
  return {
    errorCode,
    errorMessage,
    isSending,
    sendVerificationEmail,
  };
}
